import NotFoundPage from "components/error/NotFoundPage";
import PageLoading from "components/loading/PageLoading";
import { WebhooksTierInfo } from "components/TierInfo/WebhooksTierInfo";
import Box from "ds/components/Box";
import PageInfoHeader from "ds/components/PageInfoHeader";
import { useInitialSort } from "ds/components/Table/hooks/useInitialSort";
import TableSimple from "ds/components/TableSimple";
import useAnalytics from "hooks/useAnalytics";
import useErrorHandle from "hooks/useErrorHandle";
import useTitle from "hooks/useTitle";
import useWebhookDeliveries from "shared/Webhook/useWebhookDeliveries";

import { WebhookContext } from "../Context";
import useIntegrationsLayout from "../useIntegrationsLayout";
import WebhookDeliveriesEmpty from "./Empty";
import styles from "./styles.module.css";
import WEBHOOK_DELIVERIES_TABLE_CELLS from "./Table/Cells";
import {
  INITIAL_SORT_DIRECTION,
  INITIAL_SORT_OPTION,
  SORT_CONFIG,
  WEBHOOK_DELIVERIES_TABLE_FILTERS_STORAGE_KEY,
} from "./Table/constants";
import { useSortingWebhookDeliveries } from "./Table/useSortingWebhookDeliveries";
import useWebhookDeliveriesTableStore from "./Table/useTableStore";

const WebhookDeliveries = () => {
  const trackAnalytics = useAnalytics();
  const { webhook, deliveries, error, loadingContent, hasNextPage, loadMoreItems } =
    useWebhookDeliveries();

  const sortedDeliveries = useSortingWebhookDeliveries(deliveries);

  useTitle(`Webhook · ${webhook?.name ?? ""}`);
  useInitialSort(INITIAL_SORT_OPTION, INITIAL_SORT_DIRECTION);
  useIntegrationsLayout(webhook);

  const ErrorContent = useErrorHandle(error);

  if (ErrorContent) {
    return ErrorContent;
  }

  if (loadingContent) {
    return <PageLoading />;
  }

  if (!webhook) {
    return <NotFoundPage />;
  }

  return (
    <WebhookContext.Provider
      value={{
        webhook,
      }}
    >
      <WebhooksTierInfo />
      <Box direction="column" grow="1" fullWidth relative>
        <PageInfoHeader title="Recent deliveries" className={styles.pageInfo} />

        <TableSimple
          data={sortedDeliveries}
          loading={loadingContent}
          store={useWebhookDeliveriesTableStore}
          ariaLabel="Webhook deliveries"
          cellPerColumn={WEBHOOK_DELIVERIES_TABLE_CELLS}
          filtersStorageKey={WEBHOOK_DELIVERIES_TABLE_FILTERS_STORAGE_KEY}
          sortConfig={SORT_CONFIG}
          trackAnalytics={trackAnalytics}
          hasPagination={false}
          onLoadMore={hasNextPage ? loadMoreItems : undefined}
          virtualize={sortedDeliveries.length >= 50}
          emptyState={<WebhookDeliveriesEmpty />}
        />
      </Box>
    </WebhookContext.Provider>
  );
};

export default WebhookDeliveries;
